import Vue from 'vue';

import AppButtonDirective from '../directives/AppButtonDirective';
import AppBackButtonDirective from '../directives/AppBackButtonDirective';
import AppRegexFilterDirective from '../directives/AppRegexFilterDirective';

Vue.use(AppButtonDirective);
Vue.use(AppBackButtonDirective);
Vue.use(AppRegexFilterDirective);
